import { render } from "./WorkoutsListPage.vue?vue&type=template&id=57efbf4a&scoped=true&ts=true"
import script from "./WorkoutsListPage.vue?vue&type=script&lang=ts"
export * from "./WorkoutsListPage.vue?vue&type=script&lang=ts"

import "./WorkoutsListPage.vue?vue&type=style&index=0&id=57efbf4a&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57efbf4a"]])

export default __exports__